import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Flex } from 'rebass'
import Avatar from '../Avatar'
import StarRating from '../StarRating'
import moment from 'moment'
import media, { MediumScreenUp } from '../../utils/style'

const Wrapper = styled(Flex)`
  background-color: white;
  width: 100%;
  padding: 30px;
  align-items: flex-start;

  border-bottom: 1px solid ${(props) => props.theme.colors.grey_light_op30};

  &:last-child {
    border-bottom: 0;
  }

  p {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 0;
  }

  ${media.MediumScreenUp`
    padding: 60px;
  `}
`

const Author = styled.div`
  font-weight: bold;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.grey_light_op65};
  font-size: ${(props) => rem(props.theme.fontSizes[4])};
  line-height: 1.5;
  margin-right: 30px;
  margin-bottom: 10px;

  ${media.MediumScreenUp`
    margin-bottom: 0;
  `}
`

const Date = styled.span`
  font-weight: bold;
  color: ${(props) => props.theme.colors.grey_light_op65};
  font-size: ${(props) => rem(props.theme.fontSizes[4])};
  line-height: 1.5;
`

const DetailsWrapper = styled.div`
  ${media.MediumScreenUp`
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    flex-wrap: wrap;
  `}
`

const DetailsInner = styled.div`
  ${media.MediumScreenUp`
    display: flex;
  `}
`

const FullReview = ({ review }) => {
  const names = review.name.split(' ')
  if (names[0].match(/^mrs|mr|miss/i)) names.shift()
  const firstName = names[0] || ''
  const lastName = names[1] || ''
  const initials = firstName.charAt(0) + lastName.charAt(0)
  return (
    <Wrapper>
      <MediumScreenUp>
        <Avatar initials={initials} />
      </MediumScreenUp>
      <DetailsWrapper fg={1}>
        <DetailsInner>
          <Author>{review.name}</Author>
          <StarRating value={review.rating} />
        </DetailsInner>
        <Date>{moment(review.reviewDate).format('D MMMM YYYY')}</Date>
        <p>{review.content}</p>
      </DetailsWrapper>
    </Wrapper>
  )
}

export default FullReview
